import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {GrantedDirective} from './granted.directive';



@NgModule({
  declarations: [GrantedDirective],
  exports: [GrantedDirective],
  imports: [
    CommonModule
  ]
})
export class PermissionsModule { }
